import script from "./InfoGarantias.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoGarantias.vue?vue&type=script&setup=true&lang=js"

import "./InfoGarantias.vue?vue&type=style&index=0&id=cc68faa8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc68faa8"]])

export default __exports__